import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { BASE_API_URL, IBoondock } from '@curbnturf/entities';
import { CachedHttpClient } from '@curbnturf/network';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

const API_URL = BASE_API_URL + 'boondock';

@Injectable({
  providedIn: 'root',
})
export class BoondockDisplayService {
  constructor(
    private http: CachedHttpClient,
    @Inject(PLATFORM_ID) private platformId: string,
    private transferState: TransferState,
  ) {}

  fetch(boondockId: number | string): Observable<IBoondock> {
    const boondockStateKey = makeStateKey<IBoondock>('boondock-' + boondockId);

    if (this.transferState.hasKey(boondockStateKey)) {
      const boondock = this.transferState.get<IBoondock>(boondockStateKey, {});
      this.transferState.remove(boondockStateKey);
      return of(boondock);
    } else {
      return this.http
        .get<IBoondock>(`${API_URL}/${boondockId}`, undefined, {
          offlineCallback: () => ({}), // @todo cache the boondock and load from the cache
        })
        .pipe(
          tap((boondock) => {
            if (isPlatformServer(this.platformId)) {
              this.transferState.set(boondockStateKey, boondock);
            }
          }),
        );
    }
  }
}
